var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#009EDC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_4659)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_533_4659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1748 17.1904C20.7837 17.1904 21.2773 16.6957 21.2773 16.0855C21.2773 15.4752 20.7837 14.9805 20.1748 14.9805C19.5659 14.9805 19.0723 15.4752 19.0723 16.0855C19.0723 16.6957 19.5659 17.1904 20.1748 17.1904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8117 17.1905C12.4207 17.1905 12.9143 16.6957 12.9143 16.0855C12.9143 15.4752 12.4207 14.9805 11.8117 14.9805C11.2028 14.9805 10.7092 15.4752 10.7092 16.0855C10.7092 16.6957 11.2028 17.1905 11.8117 17.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6352 19.0635H20.6318V20.5996H22.6352V19.0635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6318 19.0635H9.14949C9.02848 19.0635 8.92092 18.9691 8.90747 18.8479V20.5996H20.6318V19.0635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90751 18.8209V15.1018H7.19995V18.9018C7.19995 19.845 7.95289 20.5996 8.89407 20.5996H8.90751V18.8479C8.90751 18.8344 8.90751 18.8344 8.90751 18.8209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 13.2557V15.1018H8.90751V13.3365C8.90751 13.2152 9.00163 13.1074 9.12264 13.094H7.2134C7.19995 13.1479 7.19995 13.2018 7.19995 13.2557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81338 11.5578C7.96632 11.5982 7.28061 12.2585 7.21338 13.094H9.12262C9.13607 13.094 9.13607 13.094 9.14951 13.094H21.089V11.5578H8.81338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0756 11.5578V13.094H22.8487C22.9706 13.094 23.0788 13.1883 23.0924 13.3096V11.5578H21.0756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1865 11.5578H23.0924V13.3096C23.0924 13.323 23.0924 13.323 23.0924 13.3365V18.6323H24.8V13.2557C24.7865 12.3394 24.0739 11.5982 23.1865 11.5578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7646 9.36734V11.2473H16.3966V9.34039C16.8134 9.20564 17.1226 8.84181 17.1226 8.39713C17.1226 7.84464 16.6386 7.39996 16.0335 7.39996C15.4419 7.39996 14.9445 7.84464 14.9445 8.39713C14.9579 8.86876 15.3075 9.25954 15.7646 9.36734Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_4659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 13.1997,
    fill: "white",
    transform: "translate(7.19995 7.39996)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_533_4659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 13.1997,
    fill: "white",
    transform: "translate(7.19995 7.39996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallback);
export default __webpack_public_path__ + "static/media/fallback.4dfd070aad8872249cb950c43e0f7670.svg";
export { ForwardRef as ReactComponent };